import React from 'react'
import { Edit } from 'react-admin'
import AdsSpaceForm from './form'

const AdsSpaceEdit = (props) => (
  <Edit {...props}>
    <AdsSpaceForm isEdit={true} {...props} />
  </Edit>
)

export default AdsSpaceEdit
